export default __webpack_public_path__ + "static/media/abstracto41152.27265ace.jpg";